export default {
  // Form Validations
  'form.validation.required': '{ value } is mandatory',
  'form.validation.mandatoryField': 'This field is mandatory',
  'form.validation.max': 'Should have less than { value } characters',
  'form.validation.min': 'Should have at least { value } characters',
  'form.validation.onlyAlpha': 'Should be alpha values',
  'form.validation.exactLength': 'Should have exactly { value } characters',
  'form.validation.onlyAlphaNumeric': 'Should be alphanumeric values',
  'form.validation.valueDuplicated':
    '{value} already exist. Please enter a new one',
  'form.validation.onlyNumeric': 'Should be numeric values',
  'form.validation.time': 'Time should be in this format, HH:MM',
  'form.validation.emailInvalid': 'Please enter a valid email address',
  'form.validation.termsRequired': 'Please agree to the terms and conditions'
};
